import t from"react";class e extends t.Component{constructor(r){super(r),this.state={hasError:!1}}static getDerivedStateFromError(r){return{hasError:!0}}render(){return this.state.hasError?null:this.props.children}}export{e as ErrorBoundary};
//# sourceMappingURL=ErrorBoundary.js.map
